/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SettlementCreateDto } from '../../models/settlement-create-dto';
import { SettlementDto } from '../../models/settlement-dto';

export interface SettlementControllerCreate$Params {
      body: SettlementCreateDto
}

export function settlementControllerCreate(http: HttpClient, rootUrl: string, params: SettlementControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<SettlementDto>> {
  const rb = new RequestBuilder(rootUrl, settlementControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SettlementDto>;
    })
  );
}

settlementControllerCreate.PATH = '/api/settlement';
